import React, { useEffect, useState } from 'react';
import AppBar from '@mui/material/AppBar';
import IconButton from '@mui/material/IconButton';
import MenuIcon from '@mui/icons-material/Menu';
import Brightness4Icon from '@mui/icons-material/Brightness4';
import Brightness7Icon from '@mui/icons-material/Brightness7';
import AccountCircleIcon from '@mui/icons-material/AccountCircle';
import InsertEmoticonIcon from '@mui/icons-material/InsertEmoticon';
import Box from '@mui/material/Box'
import Toolbar from '@mui/material/Toolbar';
import { Link } from 'react-router-dom';
import LogoH from './LogoH';

import List from '@mui/material/List';
import Divider from '@mui/material/Divider';
import ListItem from '@mui/material/ListItem';
import ListItemText from '@mui/material/ListItemText';
import SwipeableDrawer from '@mui/material/SwipeableDrawer';
import Chip from '@mui/material/Chip';

//Logout 
import Menu from '@mui/material/Menu';
import MenuItem from '@mui/material/MenuItem';

//Redux stuff
import { useSelector, useDispatch } from "react-redux";
import { logoutUser } from "../../reducers/authSlice";
import { changeColorMode } from "../../reducers/themeSlice";
import { ListItemButton } from '@mui/material';

import Switch from '@mui/material/Switch';
import FormControlLabel from '@mui/material/FormControlLabel';
import { styled } from '@mui/material/styles';
import { useTheme } from '@mui/material/styles'

const getIcon = (text) => {
  switch (text) {
    case 'Buscador de productos': return <Box sx={{ color: 'secondary.main' }}><i className='fad fa-inventory' style={{ transform: 'scale(1.5)' }}></i></Box>
    case 'Cotizaciones': return <Box sx={{ color: 'secondary.main' }}><i className='fad fa-file-invoice' style={{ transform: 'scale(1.5)' }}></i></Box>
    case 'Clientes y proveedores': return <Box sx={{ color: 'secondary.main' }}><i className='fad fa-users' style={{ transform: 'scale(1.5)' }}></i></Box>
    case 'Salidas de almacén': return <Box sx={{ color: 'secondary.main' }}><i className='fad fa-sign-out-alt' style={{ transform: 'scale(1.5)' }}></i></Box>
    case 'Movimientos de inventario': return <Box sx={{ color: 'secondary.main' }}><i className='fad fa-sync-alt' style={{ transform: 'scale(1.5)' }}></i></Box>
    case 'Ubicaciones de almacén': return <Box sx={{ color: 'secondary.main' }}><i className='fad fa-warehouse-alt' style={{ transform: 'scale(1.5)' }}></i></Box>
    case 'Informes y análisis': return <Box sx={{ color: 'secondary.main' }}><i className='fad fa-analytics' style={{ transform: 'scale(1.5)' }}></i></Box>
    default: return <Box sx={{ color: 'secondary.main' }}><i className='fad fa-inventory' style={{ transform: 'scale(1.5)' }}></i></Box>
  }
}

const getLink = (text) => {
  switch (text) {
    case 'Buscador de productos': return '/inventario/consultarProductos'
    case 'Cotizaciones': return '/cotizaciones'
    case 'Clientes y proveedores': return '/clientes'
    case 'Salidas de almacén': return '/inventario/salidas'
    case 'Movimientos de inventario': return '/inventario/tablaInventario'
    case 'Ubicaciones de almacén': return '/almacenes'
    case 'Informes y análisis': return '/informes'
    case 'Configuración': return '/config'
    default: return '/#'
  }
}

function NavBar(props) {

  const auth = useSelector((state) => state.auth);
  const dispatch = useDispatch();
  const theme = useTheme();

  const [dw, setDw] = useState(false);
  const [dir, setDir] = useState({ left: false });
  const [name, setName] = useState('');
  const [color, setColor] = useState(true);

  useEffect(() => {
    setColor(props.colorMode === 'dark' ? false : true);
  }, [props])

  useEffect(() => {
    if (auth.isAuthenticated) {
      setName(auth.user.name);
    }
    return () => {
      //
    };
  }, [auth]);

  const onLogoutClick = e => {
    e.preventDefault();
    setName('');
    dispatch(logoutUser());
  };

  // Logout menu stuff
  const [anchorEl, setAnchorEl] = useState(null);
  const open = Boolean(anchorEl);
  const handleClick = (event) => {
    setAnchorEl(event.currentTarget);
  };
  const handleClose = () => {
    setAnchorEl(null);
  };

  // This is the function that will be called when the user clicks the menu icon
  const toggleDrawer = (anchor, open) => (event) => {
    if (
      event &&
      event.type === 'keydown' &&
      ((event).key === 'Tab' ||
        (event).key === 'Shift')
    ) {
      return;
    }

    setDir({ ...dir, [anchor]: open });
    setDw(!dw);
  };

  const list = (anchor) => (
    <Box
      sx={{ width: anchor === 'top' || anchor === 'bottom' ? 'auto' : 300, bgcolor: 'background.paper' }}
      role="presentation"
      onClick={toggleDrawer(anchor, false)}
      onKeyDown={toggleDrawer(anchor, false)}
    >
      <div className='mb-4 mt-4'>
        <Link to={'/dashboard'} style={{ display: 'flex', alignItems: 'center', justifyContent: 'center', flexDirection: 'column' }}>
          {/* <img src="./Cronos_h.svg" alt='cronos-logo' style={{ width: '80%' }} className='img img-fluid py-1'></img> */}
          <LogoH />
        </Link>
      </div>
      <List>
        {['Buscador de productos', 'Cotizaciones', 'Salidas de almacén', 'Clientes y proveedores', 'Movimientos de inventario', 'Ubicaciones de almacén', 'Informes y análisis'].map((text, index) => (
          <Link key={text} style={{textDecoration: 'none'}}  to={getLink(text)}>
            <ListItem sx={{ '&.MuiListItem-padding': { padding: '0px !important' } }} >
              <ListItemButton sx={{ display: 'flex', flexDirection: 'row-reverse', padding: '12px 16px 12px 16px' }}>
                {getIcon(text)}
                <ListItemText sx={{ color: 'text.primary', '& .css-10hburv-MuiTypography-root' : {fontWeight: 500}}} primary={text} />
              </ListItemButton>
            </ListItem>
          </Link>
        ))}
      </List>
      <Divider />
      <List>
        {['Configuración'].map((text, index) => (
          <Link key={text} style={{textDecoration: 'none'}} to={getLink(text)}>
            <ListItem sx={{ '&.MuiListItem-padding': { padding: '0px !important' } }}>
              <ListItemButton>
                <ListItemText sx={{ color: 'text.primary', '& .css-10hburv-MuiTypography-root' : {fontWeight: 500} }} primary={text} />
              </ListItemButton>
            </ListItem>
          </Link>
        ))}
        <ListItem onClick={onLogoutClick} sx={{ '&.MuiListItem-padding': { padding: '0px !important' } }}>
          <ListItemButton>
            <ListItemText sx={{ color: 'text.primary', '& .css-10hburv-MuiTypography-root' : {fontWeight: 500} }} primary='Cerrar sesión' />
          </ListItemButton>
        </ListItem>
      </List>
    </Box >
  );

  const handleColorMode = () => {
    const tmp = !color ? 'light' : 'dark';
    dispatch(changeColorMode(tmp));
    setColor(tmp);
  }

  return (
    <div>
      <Box sx={{ flexGrow: 1 }} >
        <AppBar position="static" sx={{ backgroundColor: 'comp.navbarBg', height: '60px', justifyContent: 'center' }} elevation={3}>
          <Toolbar style={{ dispay: 'flex', justifyContent: 'space-between' }} variant="dense">
            <IconButton
              size="large"
              edge="start"
              color="secondary"
              aria-label="menu"
              sx={{ mr: 2 }}
              onClick={toggleDrawer('left', true)}
              style={{ display: `${name ? 'flex' : 'none'}` }}
            >
              <MenuIcon fontSize='large' />
            </IconButton>
            <Link to="/dashboard" style={{ textDecoration: 'none' }}>
              {/* <img src="./Cronos_h.svg" alt='cronos-logo' style={{ height: '48px', width: 'auto' }} className='img img-fluid py-1'></img> */}
              <Box style={{ transform: 'scale(0.65)' }}>
                <LogoH />
              </Box>
            </Link>
            <Box style={{ display: `${name ? 'flex' : 'none'}` }}>
              <FormControlLabel
                control={<MaterialUISwitch sx={{ mr: 1 }} checked={!color} onChange={handleColorMode} theme={theme}/>}
              />
              <IconButton
                id="basic-button"
                aria-controls={open ? 'basic-menu' : undefined}
                aria-haspopup="true"
                aria-expanded={open ? 'true' : undefined}
                onClick={handleClick}
                variant='contained'
                color='info'
              >
                <AccountCircleIcon fontSize='large' />
              </IconButton>
              <Menu
                id="basic-menu"
                anchorEl={anchorEl}
                open={open}
                onClose={handleClose}
                MenuListProps={{
                  'aria-labelledby': 'basic-button',
                }}
              >
                <MenuItem ><Chip label={name} icon={<InsertEmoticonIcon />} /></MenuItem>
                <MenuItem onClick={onLogoutClick}>Cerrar sesión</MenuItem>
              </Menu>
            </Box>
          </Toolbar>
        </AppBar>
      </Box>
      <SwipeableDrawer
        anchor={'left'}
        open={dir['left']}
        onClose={toggleDrawer('left', false)}
        onOpen={toggleDrawer('left', true)}
      >
        {list('left')}
      </SwipeableDrawer>
    </div >
  );
}

const MaterialUISwitch = styled(Switch)(({ theme }) => ({
  width: 62,
  height: 34,
  padding: 7,
  '& .MuiSwitch-switchBase': {
    margin: 1,
    padding: 0,
    transform: 'translateX(6px)',
    '&.Mui-checked': {
      color: '#fff',
      transform: 'translateX(22px)',
      '& .MuiSwitch-thumb:before': {
        backgroundImage: `url('data:image/svg+xml;utf8,<svg xmlns="http://www.w3.org/2000/svg" height="20" width="20" viewBox="0 0 20 20"><path fill="${encodeURIComponent(
          '#fff',
        )}" d="M4.2 2.5l-.7 1.8-1.8.7 1.8.7.7 1.8.6-1.8L6.7 5l-1.9-.7-.6-1.8zm15 8.3a6.7 6.7 0 11-6.6-6.6 5.8 5.8 0 006.6 6.6z"/></svg>')`,
      },
      '& + .MuiSwitch-track': {
        opacity: 1,
        backgroundColor: theme.palette.mode === 'dark' ? '#8796A5' : '#aab4be',
      },
    },
  },
  '& .MuiSwitch-thumb': {
    backgroundColor: theme.palette.mode === 'dark' ? theme.palette.secondary.main : theme.palette.primary.main,
    width: 32,
    height: 32,
    '&:before': {
      content: "''",
      position: 'absolute',
      width: '100%',
      height: '100%',
      left: 0,
      top: 0,
      backgroundRepeat: 'no-repeat',
      backgroundPosition: 'center',
      backgroundImage: `url('data:image/svg+xml;utf8,<svg xmlns="http://www.w3.org/2000/svg" height="20" width="20" viewBox="0 0 20 20"><path fill="${encodeURIComponent(
        '#fff',
      )}" d="M9.305 1.667V3.75h1.389V1.667h-1.39zm-4.707 1.95l-.982.982L5.09 6.072l.982-.982-1.473-1.473zm10.802 0L13.927 5.09l.982.982 1.473-1.473-.982-.982zM10 5.139a4.872 4.872 0 00-4.862 4.86A4.872 4.872 0 0010 14.862 4.872 4.872 0 0014.86 10 4.872 4.872 0 0010 5.139zm0 1.389A3.462 3.462 0 0113.471 10a3.462 3.462 0 01-3.473 3.472A3.462 3.462 0 016.527 10 3.462 3.462 0 0110 6.528zM1.665 9.305v1.39h2.083v-1.39H1.666zm14.583 0v1.39h2.084v-1.39h-2.084zM5.09 13.928L3.616 15.4l.982.982 1.473-1.473-.982-.982zm9.82 0l-.982.982 1.473 1.473.982-.982-1.473-1.473zM9.305 16.25v2.083h1.389V16.25h-1.39z"/></svg>')`,
    },
  },
  '& .MuiSwitch-track': {
    opacity: 1,
    backgroundColor: theme.palette.mode === 'dark' ? '#8796A5' : '#aab4be',
    borderRadius: 20 / 2,
  },
}));

export default NavBar;